import type { HTMLAttributes } from 'react';

import { useSqwLayout } from '../SqwLayoutContext';
import { S } from './Backdrop.styles';

export const Backdrop = (props: HTMLAttributes<HTMLDivElement>) => {
  const { isMobileSidebarExpanded, setIsMobileSidebarExpanded } = useSqwLayout();

  return (
    <S.Backdrop isVisible={isMobileSidebarExpanded} onClick={() => setIsMobileSidebarExpanded(false)} {...props} />
  );
};
